import { Text, VStack } from "@chakra-ui/react";
import { SearchAndFilterTypes } from "src/constants";
import {
  CommonFilterProps,
  DynamicSelectFilter,
  Option,
} from "../CommonFilters";

export interface QuestionFilterProps {
  questionId: uuid;
  questionLabel: string;
  options: Option[];
}

const buildOptionId = (id: uuid, questionId: uuid) => `${id}~${questionId}`;

type DynamicQuestionFilterProps = QuestionFilterProps & CommonFilterProps;
export const DynamicQuestionFilter = ({
  questionId,
  questionLabel,
  options,
  ...props
}: DynamicQuestionFilterProps) => {
  const optionsWithQuestionId = options.map(({ id, label }) => ({
    id: buildOptionId(id, questionId),
    label,
  }));
  return (
    <VStack align="inherit">
      <Text size="sm" fontWeight="400">
        {questionLabel}
      </Text>
      <DynamicSelectFilter
        optionStyle={
          optionsWithQuestionId.length <= 3 ? "button" : "multiSelect"
        }
        options={optionsWithQuestionId}
        filterKey={SearchAndFilterTypes.DynamicQuestions}
        placeholder="Type an answer"
        {...props}
      />
    </VStack>
  );
};
